import DataTableRow from "./DataTableRow"
import PropTypes from "prop-types"
import React from "react"

class DataTableRows extends React.Component {
    renderRows() {
        if (this.props.rowsData && this.props.rowsData.length) {
            const rows = this.props.rowsData.map((rowData, i) => {
                return (
                    <DataTableRow
                        key={i}
                        index={i}
                        rowData={rowData}
                        colDefs={this.props.colDefs}
                        customTableProps={this.props.customTableProps}
                        visibleColumnKeys={this.props.visibleColumnKeys}
                        onRowClick={this.props.onRowClick}
                    />
                )
            })

            return rows
        } else {
            return null
        }
    }

    render() {
        return this.renderRows()
    }

    static propTypes = {
        rowsData: PropTypes.array,
        colDefs: PropTypes.array.isRequired,
        customTableProps: PropTypes.object,
        className: PropTypes.string,
        rowClassName: PropTypes.string,
        visibleColumnKeys: PropTypes.array,
        onRowClick: PropTypes.func
    }
}

export default DataTableRows
